import { MapCardProps } from './MapCard'
import { Spacer } from '@/components/elements/Spacer'

export const cpMapList: Array<MapCardProps> = [
  {
    cpName: '本社',
    cpSubName:
      '株式会社トライアルホールディングス・株式会社トライアルカンパニー',
    cpAddress: '〒813-0034 　福岡市東区多の津1丁目12番2号',
    addressUrl:
      'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3322.2118348495715!2d130.448264!3d33.625749!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xfe465403033e9c51!2z5qCq5byP5Lya56S-44OI44Op44Kk44Ki44Or44Kr44Oz44OR44OL44O8!5e0!3m2!1sja!2sjp!4v1637135606813!5m2!1sja!2sjp',
    children: (
      <>
        <Spacer h={{ sp: 40, pc: 42 }} />
        <h4>[交通アクセス]</h4>
        <Spacer h={{ sp: 36, pc: 30 }} />
        <h5>バスをご利用の場合</h5>
        <Spacer h={{ sp: 15, pc: 12 }} />
        <p>
          博多（博多駅バスターミナル）より、14番乗場で73番「土井営業所」「土井団地」もしくは「みどりが丘団地入口」行のバスをご利用ください。「オロシアムFUKUOKA（旧卸会館前）」で下車し、徒歩2、3分
        </p>
        <Spacer h={{ sp: 42, pc: 45 }} />
        <h5>電車をご利用の場合</h5>
        <Spacer h={{ sp: 15, pc: 12 }} />
        <p>
          JR箱崎駅を出て箱崎駅西口バス停留所より、78番「土井団地」もしくは「みどりが丘団地入口」行のバスをご利用ください。「オロシアムFUKUOKA（旧卸会館前）」で下車し、徒歩2、3分<br/>
          JR千早駅を出て千早駅前バス停より、3番「土井営業所」行のバスをご利用ください。「オロシアムFUKUOKA（旧卸会館前）」で下車し、徒歩2、3分
        </p>
        <Spacer h={{ sp: 30, pc: 83 }} />
      </>
    ),
  },
  {
    cpName: '東京オフィス',
    cpSubName:
      '株式会社トライアルホールディングス・株式会社トライアルカンパニー',
    cpAddress: '〒108-0023 　東京都港区芝浦三丁目16番16号 住友不動産田町ビル東館 5F（総合受付）',
    addressUrl:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3242.4283164152293!2d139.7465946762298!3d35.641817532137466!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188baedb024a65%3A0x47684ad20e4e676d!2sSumitomo%20Fudosan%20Tamachi%20Bldg.%20Higashikan!5e0!3m2!1szh-CN!2sjp!4v1773992257009!5m2!1sja!2sjp',
    children: (
      <>
        <Spacer h={{ sp: 40, pc: 42 }} />
        <h4>[交通アクセス]</h4>
        <Spacer h={{ sp: 36, pc: 38 }} />
        <p>
          JR「田町駅」芝浦口より徒歩8分
        </p>
        <p>
          都営地下鉄浅草線・三田線「三田駅」A4出口より徒歩10分
        </p>
        <Spacer h={{ sp: 30, pc: 83 }} />
      </>
    ),
  },
  {
    cpName: 'MUSUBU AI',
    cpAddress: '〒822-0133 　福岡県宮若市脇田394',
    addressUrl:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3319.436704756755!2d130.58937415126087!3d33.697647080609194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35422b313d65e311%3A0x31f30c72bdb6e149!2sMUSUBU%20AI!5e0!3m2!1sja!2sjp!4v1675659119658!5m2!1sja!2sjp',
    children: (
      <>
        <Spacer h={{ sp: 40, pc: 42 }} />
        <h4>[交通アクセス]</h4>
        <Spacer h={{ sp: 36, pc: 30 }} />
        <h5>車をご利用の場合</h5>
        <Spacer h={{ sp: 15, pc: 12 }} />
        <p>福岡空港より車で約50分</p>
        <Spacer h={{ sp: 42, pc: 45 }} />
        <h5>バスをご利用の場合</h5>
        <Spacer h={{ sp: 15, pc: 12 }} />
        <p>
          JR九州バス：博多バスターミナル3階33番乗り場より山の神・直方行き「吉川校前」下車徒歩1分
        </p>
        <Spacer h={{ sp: 30, pc: 83 }} />
      </>
    ),
  },
  {
    cpName: 'TRIAL IoT Lab',
    cpAddress: '〒823-0013 　福岡県宮若市芹田9',
    addressUrl:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3317.948164801104!2d130.63934125126173!3d33.73615648059844!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3543d51fc82207b7%3A0xcae303a2ae31b067!2sTRIAL%20IoT%20Lab!5e0!3m2!1sja!2sjp!4v1675659770154!5m2!1sja!2sjp',
    children: (
      <>
        <Spacer h={{ sp: 40, pc: 42 }} />
        <h4>[交通アクセス]</h4>
        <Spacer h={{ sp: 36, pc: 30 }} />
        <h5>車をご利用の場合</h5>
        <Spacer h={{ sp: 15, pc: 12 }} />
        <p>福岡空港より車で約60分</p>
        <Spacer h={{ sp: 42, pc: 45 }} />
        <h5>バスをご利用の場合</h5>
        <Spacer h={{ sp: 15, pc: 12 }} />
        <p>
          JR九州バス：博多バスターミナル3階33番乗り場より山の神・直方行き「筑前芹田」下車徒歩5分
        </p>
        <Spacer h={{ sp: 30, pc: 83 }} />
      </>
    ),
  },
]
